import { useEffect, useState } from "react";
import { navItems, siteInfo } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/whatsapp";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const solid = scrolled || open;
  const waLink = buildWhatsAppLink(siteInfo.defaultMessage);

  const linkColor = solid
    ? "text-foreground-700 hover:text-primary-600"
    : "text-background-100 hover:text-accent-300";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 shadow-[0_1px_0_0_oklch(var(--background-300))] backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="flex w-full items-center justify-between gap-4 px-5 py-3.5 md:px-8 lg:px-12">
        <a href="#anasayfa" className="flex items-center gap-3" aria-label={siteInfo.brand}>
          <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full ring-1 ring-accent-500/60 md:h-14 md:w-14">
            <img
              src={siteInfo.logo}
              alt="Fatma Angay Güzellik Salonu logosu"
              title="Fatma Angay Güzellik Salonu"
              className="h-full w-full object-contain"
            />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-semibold tracking-wide md:text-xl ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              FATMA ANGAY
            </span>
            <span className="font-label text-[0.6rem] font-medium uppercase tracking-[0.34em] text-accent-600 md:text-[0.65rem]">
              Güzellik Salonu
            </span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`whitespace-nowrap font-label text-sm font-medium tracking-wide transition-colors ${linkColor}`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-accent-500 px-5 py-3 font-label text-xs font-semibold uppercase tracking-[0.14em] text-accent-600 transition-colors hover:bg-accent-500 hover:text-primary-950 lg:inline-flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-whatsapp-line text-base" aria-hidden="true" />
            </span>
            WhatsApp’tan Randevu Al
          </a>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={open}
            className={`flex h-11 w-11 cursor-pointer items-center justify-center rounded-md border transition-colors lg:hidden ${
              solid
                ? "border-background-300 text-foreground-900"
                : "border-background-100/50 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open ? (
        <div className="lg:hidden">
          <div className="mx-4 mb-4 rounded-xl border border-background-200 bg-background-50 p-3">
            <ul className="flex flex-col">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setOpen(false)}
                    className="flex items-center justify-between rounded-lg px-4 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-lg text-accent-600" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-accent-500 px-5 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-primary-950 transition-colors hover:bg-accent-400"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              </span>
              WhatsApp’tan Randevu Al
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}